import script from "./SuccessSnackbar.vue?vue&type=script&setup=true&lang=js"
export * from "./SuccessSnackbar.vue?vue&type=script&setup=true&lang=js"

import "./SuccessSnackbar.vue?vue&type=style&index=0&id=428cb324&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-428cb324"]])

export default __exports__